var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        staticClass: "form-control",
        attrs: { placeholder: _vm.schema.placeholder },
        domProps: { value: _vm.value },
        on: {
          focus: function($event) {
            _vm.open = false
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.open
        ? _c("Chrome", {
            staticClass: "color-picker",
            attrs: { disableAlpha: true, disableFields: true },
            nativeOn: {
              click: function($event) {
                _vm.$nextTick(function() {
                  return (_vm.open = true)
                })
              }
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          on: {
            click: function($event) {
              _vm.open = !_vm.open
            }
          }
        },
        [_c("span", { style: { background: _vm.indicator } }, [_vm._v(" ")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d33ce70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d33ce70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/form/ColorPicker.vue
// module id = null
// module chunks = 